import Indexdasboard from "../../components/dashboard/IndexDashbord";
import React, { useEffect, useState, useCallback } from "react";
import { Api_Token } from "../../util/Api";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  Button,
  CardContent,
  Pagination,
} from "@mui/material";
import { useNavigate, useParams } from "react-router";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { formatDateTime } from "../../services/functions";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import { useTranslation } from "react-i18next";
import LabelTypography from "../../components/Typography/LabelTypography";

export default function TransactionParCaissePage() {
  return <Indexdasboard Children={<TransactionParCaisse />} />;
}

function TransactionParCaisse() {
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [CaisseInfo, setCaisseInfo] = useState({});
  //const [AlertEtat, setAlertEtat] = useState("inisial");
  //const [AlertMessage, setAlertMessage] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const fetchTransactions = useCallback(
    async (currentPage, rowsPerPage) => {
      try {
        const response = await Api_Token.get(
          `/transaction/getTransactionByCaisseJournyPaginate/${id}?page=${
            currentPage + 1
          }&perPage=${rowsPerPage}`
        );
        setTransactions(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    },
    [id]
  );

  useEffect(() => {
    fetchTransactions(page, rowsPerPage);
  }, [fetchTransactions, page, rowsPerPage]);

  useEffect(() => {
    const fetchCaisseInfo = async () => {
      try {
        const response = await Api_Token.get(`CaisseJourney/getOne/${id}`);
        setCaisseInfo(response.data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchCaisseInfo(); // Call the async function inside useEffect
  }, [id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function Export() {
    try {
      const response = await Api_Token.get(
        `/transaction/getTransactionByCaisseJournyExcel/${id}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "transactions.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting transactions:", error);
    }
  }
  return (
    <Box>
      <TitreGraphik>
        <span onClick={() => navigate(-1)}>⬅</span>
        {t("Transactions for CaisseJourney {{id}}", { id })}
      </TitreGraphik>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Card sx={{ padding: "2%", marginTop: "2%", width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <LabelTypography>
                <b>{t("Open :")}</b> {formatDateTime(CaisseInfo?.dateOpen)}
              </LabelTypography>
            </Grid>
            <Grid item xs={6}>
              <LabelTypography>
                <b>{t("Close :")}</b> {formatDateTime(CaisseInfo?.dateClose)}
              </LabelTypography>
            </Grid>
            <Grid item xs={6}>
              <LabelTypography>
                <b>{t("Montant Depart : ")}</b>{" "}
                <NumericFormatEnv Number={CaisseInfo.montantDepart} />
              </LabelTypography>
            </Grid>
            <Grid item xs={6}>
              <LabelTypography>
                <b>{t("montant now : ")}</b>
                <NumericFormatEnv Number={CaisseInfo.montantNow} />
              </LabelTypography>
            </Grid>
            <Grid item xs={6}>
              <LabelTypography>
                <b>{t("montant cash : ")}</b>
                <NumericFormatEnv Number={CaisseInfo.totalCash} />
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" onClick={Export}>
                Export
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ marginTop: "20px" }}>
                <Table sx={{ minWidth: 650 }} aria-label="transactions table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {t("ID")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Montant")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Payment Method")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Caissier")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Created At")}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {transactions.map((transaction) => (
                      <StyledTableRow key={transaction.id}>
                        <StyledTableCell align="center">
                          #{transaction.id}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <NumericFormatEnv Number={transaction.montant} />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {transaction.payment_method}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {transaction.commercial.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {new Date(transaction.created_at).toLocaleString()}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Grid>
        </Card>
      </Box>
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid item xs={12}>
              <LabelTypography>
                <b>{t("Open :")}</b> {formatDateTime(CaisseInfo?.dateOpen)}
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <LabelTypography>
                <b>{t("Close :")}</b> {formatDateTime(CaisseInfo?.dateClose)}
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <LabelTypography>
                <b>{t("Montant Depart : ")}</b>{" "}
                <NumericFormatEnv Number={CaisseInfo.montantDepart} />
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <LabelTypography>
                <b>{t("montant now : ")}</b>
                <NumericFormatEnv Number={CaisseInfo.montantNow} />
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <LabelTypography>
                <b>{t("montant cash : ")}</b>
                <NumericFormatEnv Number={CaisseInfo.totalCash} />
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" fullWidth onClick={Export}>
                Export
              </Button>
            </Grid>
            {transactions.map((transaction) => (
              <Grid item xs={12} sm={6} md={4} key={transaction.id}>
                <Card sx={{ padding: 2 }}>
                  <CardContent>
                    <LabelTypography variant="h6" align="center">
                      #{transaction.id}
                    </LabelTypography>
                    <LabelTypography variant="body1">
                      <strong>{t("Montant")}:</strong>{" "}
                      <NumericFormatEnv Number={transaction.montant} />
                    </LabelTypography>
                    <LabelTypography variant="body1">
                      <strong>{t("Payment Method")}:</strong>{" "}
                      {transaction.payment_method}
                    </LabelTypography>
                    <LabelTypography variant="body1">
                      <strong>{t("Caissier")}:</strong>{" "}
                      {transaction.commercial.name}
                    </LabelTypography>
                    <LabelTypography variant="body1">
                      <strong>{t("Created At")}:</strong>{" "}
                      {new Date(transaction.created_at).toLocaleString()}
                    </LabelTypography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Box
                sx={{
                  marginTop: "3%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Pagination
                  count={Math.ceil(totalCount / rowsPerPage)}
                  onChange={(event, newPage) => {
                    setPage(newPage - 1);
                  }}
                  variant="outlined"
                  color="primary"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
